// Shared list of payment methods used by the Basket page and BasketInvoiceInputs.
// IDs are persisted on the backend via the checkout payload's `paymentMethod`,
// so they must NOT be renumbered.
export interface IPaymentMethod {
  id: number;
  name: string;
}

export const PAYMENT_METHODS: IPaymentMethod[] = [
  { id: 0, name: "Cash" },
  { id: 1, name: "Card" },
  // { id: 2, name: "eBay" }, // intentionally hidden — kept reserved.
  { id: 3, name: "Stripe" },
  { id: 4, name: "Bank Transfer" },
  { id: 5, name: "Cheque" },
];
